import { Box, Typography } from "@mui/material";

import { EmptyPanelMessage, NestedPanel, SectionTitleRow } from "../primitives";
import { BODY, MUTED, PRIMARY_BLUE } from "../tokens";

export default function TopWritersPanel({ topWriters, onExplore }) {
  return (
    <NestedPanel sx={{ minHeight: 209 }}>
      <SectionTitleRow label="Top Writers - Referrals" onExplore={onExplore} />
      {topWriters.columns.length > 0 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: 1.25,
          }}
        >
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              color: MUTED,
            }}
          >
            HCP
          </Typography>
          <Box sx={{ display: "flex", gap: 2.5, flexShrink: 0 }}>
            {topWriters.columns.map((column) => (
              <Typography
                key={column.key}
                sx={{
                  fontSize: 11,
                  fontWeight: 600,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: MUTED,
                  minWidth: 64,
                  textAlign: "right",
                }}
              >
                {column.label}
              </Typography>
            ))}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            height: 150,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyPanelMessage>No insights found</EmptyPanelMessage>
        </Box>
      )}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
        {topWriters.rows.map((writer, index) => (
          <Box
            key={writer.name || index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  bgcolor: PRIMARY_BLUE,
                  color: "#fff",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  fontSize: 11,
                  fontWeight: 700,
                }}
              >
                {index + 1}
              </Box>
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: BODY,
                  whiteSpace: "nowrap",
                }}
              >
                {writer.name}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2.5,
                flexShrink: 0,
              }}
            >
              {topWriters.columns.map((column) => (
                <Typography
                  key={column.key}
                  sx={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: BODY,
                    minWidth: 64,
                    textAlign: "right",
                  }}
                >
                  {writer.values?.[column.key] ?? "0"}
                </Typography>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </NestedPanel>
  );
}
